import { $toast } from "vuetify-snackbar-toast";

export default function $handleError(error) {
  if (error?.message && !error.message.includes("Unauthenticated")) {
    $toast.danger(error.message);
    return;
  }

  if (error?.response?.data?.errors && typeof error.response.data.errors === "object") {
    const errorMessages = Object.values(error.response.data.errors).flat();
    errorMessages.forEach((message) => {
      $toast.danger(message);
    });
    return;
  }

  if (error?.response?.data?.message) {
    $toast.danger(error.response.data.message);
    return;
  }

  if (error?.message) {
    $toast.danger(error.message);
    return;
  }

  $toast.danger("Ocorreu um erro inesperado. Por favor, tente novamente.");
}

export const handleErrorPlugin = (vue) => {
  vue.prototype.$handleError = $handleError;
};
